export enum AdminQueryPriority {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
}

export enum AdminQueryStatus {
	PENDING = 'pending',
	IN_PROGRESS = 'in-progress',
	RESOLVED = 'resolved',
}